export const ScheduleTable = ({ schedules, loading, onRowClick }) => {
    const dias = [
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
        "Domingo",
    ];

    return (
        <div className=" border-gray-200 dark:border-gray-700 max-h-[70dvh] overflow-auto">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm table-fixed">
                <thead className="bg-white dark:bg-gray-900">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-semiblod text-gray-500 dark:text-gray-300 tracking-wider w-48">
                            Doctor
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-semiblod text-gray-500 dark:text-gray-300 tracking-wider w-20">
                            Duración
                        </th>
                        {dias.map((dia) => (
                            <th className="px-6 py-3 text-left text-xs font-semiblod text-gray-500 dark:text-gray-300 tracking-wider w-32">
                                {dia}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className="text-gray-600 dark:text-gray-400 font-medium">
                    {loading ? (
                        <tr>
                            <td
                                colSpan={9}
                                className="px-6 py-8 text-center text-gray-500 dark:text-gray-400"
                            >
                                <div className="flex items-center justify-center space-x-2">
                                    <div className="w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                                </div>
                            </td>
                        </tr>
                    ) : (
                        schedules.map((schedule, idx) => (
                            <tr
                                key={idx}
                                className={`${
                                    idx % 2 === 0
                                        ? "bg-white dark:bg-gray-900"
                                        : "bg-gray-50 dark:bg-gray-800"
                                } hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors cursor-pointer`}
                                onClick={() => onRowClick?.(schedule)}
                            >
                                <td className="px-6 py-4 whitespace-nowrap">
                                    {`${
                                        schedule.doctor.firstName?.split(
                                            " "
                                        )[0] || ""
                                    } ${
                                        schedule.doctor.lastName?.split(
                                            " "
                                        )[0] || ""
                                    }`}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    {schedule.duration} min
                                </td>
                                {dias.map((dia) => {
                                    const slot = schedule.slots.find(
                                        (s) => s.dayName === dia
                                    );
                                    return (
                                        <td
                                            key={dia}
                                            className={`px-6 py-4 whitespace-nowrap border-x h-24 border-gray-200 dark:border-gray-700 overflow-auto  ${
                                                !slot && "bg-red-200"
                                            }`}
                                        >
                                            <div className="flex flex-col justify-center h-full gap-1">
                                                {slot &&
                                                    slot.timeRanges.length >
                                                        0 &&
                                                    slot.timeRanges.map(
                                                        (r, i) => (
                                                            <span key={i}>
                                                                {r.startTime.slice(
                                                                    0,
                                                                    5
                                                                )}{" "}
                                                                -{" "}
                                                                {r.endTime.slice(
                                                                    0,
                                                                    5
                                                                )}
                                                            </span>
                                                        )
                                                    )}
                                            </div>
                                        </td>
                                    );
                                })}
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};
